import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export const routes = [
  {
    path: '/',
    component: () => import('./views/index.vue'),
    children: [
      {
        path: '/college',
        component: () => import('./components/layout.vue'),
        meta: {title: '学风管理', icon: 'el-icon-menu', perm: 'college-index-manager'},
        children: [
          {
            path: '/college/statistics/school',
            component: () => import('./views/college/attendance-statistics/index.vue'),
            meta: {title: '全校学生考勤统计', type: 0, perm: 'stat-stu-school'}
          },
          {
            path: '/college/statistics/unit',
            component: () => import('./views/college/attendance-statistics/index.vue'),
            meta: {title: '学院学生考勤统计', type: 1, perm: 'stat-stu-unit'}
          },
          {
            path: '/college/statistics/teacher',
            component: () => import('./views/college/attendance-statistics/index.vue'),
            meta: {title: '班主任所带学生考勤统计', type: 2, perm: 'stat-stu-teacher'}
          },
          {
            path: '/college/detail/school',
            component: () => import('./views/college/course-detail/index.vue'),
            meta: {title: '全校考勤明细', type: 0, perm: 'check-in-student-detail-school'}
          },
          {
            path: '/college/detail/unit',
            component: () => import('./views/college/course-detail/index.vue'),
            meta: {title: '学院学生考勤明细', type: 1, perm: 'check-in-student-detail-unit'}
          },
          {
            path: '/college/detail/teacher',
            component: () => import('./views/college/course-detail/index.vue'),
            meta: {title: '班主任所带学生考勤明细', type: 2, perm: 'check-in-student-detail-teacher'}
          },
          {
            path: '/college/student-course/school',
            component: () => import('./views/college/student-course/index.vue'),
            meta: {title: '全校学生课程考勤统计', type: 0, perm: 'stu-course-school'}
          },
          {
            path: '/college/student-course/unit',
            component: () => import('./views/college/student-course/index.vue'),
            meta: {title: '学院学生课程考勤统计', type: 1, perm: 'stu-course-unit'}
          },
          {
            path: '/college/student-course/teacher',
            component: () => import('./views/college/student-course/index.vue'),
            meta: {title: '班主任所带学生课程考勤统计', type: 2, perm: 'stu-course-teacher'}
          },
          {
            path: '/college/student-leave/school',
            component: () => import('./views/college/student-leave/index.vue'),
            meta: {title: '全校学生请假记录', type: 0, perm: 'stu-leave-school'}
          },
          {
            path: '/college/student-leave/unit',
            component: () => import('./views/college/student-leave/index.vue'),
            meta: {title: '学院学生请假记录', type: 1, perm: 'stu-leave-unit'}
          },
          {
            path: '/teacher/student-warn/school',
            component: () => import('./views/college/student-warn/index.vue'),
            meta: {title: '全校学生预警记录', type: 0, perm: 'stu-warn-school'}
          },
          {
            path: '/teacher/student-warn/unit',
            component: () => import('./views/college/student-warn/index.vue'),
            meta: {title: '学院学生预警记录', type: 1, perm: 'stu-warn-unit'}
          }
        ]
      },
      {
        path: '/teacher',
        component: () => import('./components/layout.vue'),
        meta: {title: '教风管理', icon: 'el-icon-tickets', perm: 'teacher-index-manager'},
        children: [
          {
            path: '/teacher/stats-detail/school',
            component: () => import('./views/teacher/stats-detail/index.vue'),
            meta: {title: '全校考勤统计', type: 0, perm: 'stats-school'}
          },
          {
            path: '/teacher/stats-detail/class-school',
            component: () => import('./views/teacher/stats-detail/index.vue'),
            meta: {title: '全校班级考勤统计', type: 1, perm: 'class-stats-school'}
          },
          {
            path: '/teacher/stats-detail/class-unit',
            component: () => import('./views/teacher/stats-detail/index.vue'),
            meta: {title: '学院班级考勤统计', type: 2, perm: 'class-stats-unit'}
          },
          {
            path: '/teacher/school',
            component: () => import('./views/teacher/attendance-statistics/index.vue'),
            meta: {title: '全校教学课程考勤统计', type: 0, perm: 'teacher-school'}
          },
          {
            path: '/teacher/unit',
            component: () => import('./views/teacher/attendance-statistics/index.vue'),
            meta: {title: '学院教学课程考勤统计', type: 1, perm: 'teacher-unit'}
          },
          {
            path: '/teacher/college/school',
            component: () => import('./views/teacher/course-attendance-statistics/index.vue'),
            meta: {title: '全校教师授课考勤统计', type: 0, perm: 'teacher-course-school'}
          },
          {
            path: '/teacher/college/unit',
            component: () => import('./views/teacher/course-attendance-statistics/index.vue'),
            meta: {title: '学院教师授课考勤统计', type: 1, perm: 'teacher-course-unit'}
          },
          {
            path: '/teacher/college/school-detail',
            component: () => import('./views/teacher/checkin-record-detail/index.vue'),
            meta: {title: '全校教师授课考勤明细', type: 0, perm: 'teacher-course-detail-school'}
          },
          {
            path: '/teacher/college/unit-detail',
            component: () => import('./views/teacher/checkin-record-detail/index.vue'),
            meta: {title: '学院教师授课考勤明细', type: 1, perm: 'teacher-course-detail-unit'}
          },
          {
            path: '/teacher/usage/school',
            component: () => import('./views/teacher/usage-rate/index.vue'),
            meta: {title: '学院使用率', type: 0, perm: 'usage-school'}
          },
          {
            path: '/teacher/usage/teacher',
            component: () => import('./views/teacher/usage-rate/index.vue'),
            meta: {title: '全校教师使用率', type: 1, perm: 'usage-teacher'}
          },
          {
            path: '/teacher/usage/unit',
            component: () => import('./views/teacher/usage-rate/index.vue'),
            meta: {title: '学院教师使用率', type: 2, perm: 'usage-unit'}
          },
          {
            path: '/teacher/stat/school',
            component: () => import('./views/teacher/stat/index.vue'),
            meta: {title: '全校教师考勤课时统计', type: 0, perm: 'teacher-stats'}
          },
          {
            path: '/teacher/stat/unit',
            component: () => import('./views/teacher/stat/index.vue'),
            meta: {title: '学院教师考勤课时统计', type: 1, perm: 'teacher-stats-unit'}
          }
        ]
      },
      {
        path: '/system/setting',
        component: () => import('./components/layout.vue'),
        meta: {title: '系统设置', icon: 'el-icon-setting', perm: 'system-manager'},
        children: [
          {
            path: '/system/setting/user',
            component: () => import('./views/system/user/index.vue'),
            meta: {title: '用户角色管理', perm: 'user-list'}
          },
          {
            path: '/system/setting/role',
            component: () => import('./views/system/role/index.vue'),
            meta: {title: '角色菜单管理', perm: 'view-role'}
          },
          {
            path: '/system/setting/invalid-course',
            component: () => import('./views/system/my/invalidCourse.vue'),
            meta: {title: '无效课程', perm: 'invalid-course'}
          },
          /*{
            path: '/system/setting/import',
            component: () => import('./views/system/my/import.vue'),
            meta: {title: '课程导入', perm: 'course-import'}
          },*/
          {
            path: '/system/setting/importPublicLeave',
            component: () => import('./views/system/my/importPublicLeave.vue'),
            meta: {title: '公假导入', perm: 'public-leave-import'}
          },
          {
            path: '/system/setting/holiday',
            component: () => import('./views/system/my/holiday.vue'),
            meta: {title: '假期设置', perm: 'holiday'}
          },
          {
            path: '/system/setting/semester_import',
            component: () => import('./views/system/my/semester_import.vue'),
            meta: {title: '校历设置', perm: 'semester-import'}
          },
          {
            path: '/system/setting/absent-warn-teacher',
            component: () => import('./views/system/absentWarnTeacher/index.vue'),
            meta: {title: '学勤预警辅导员设置', perm: 'absent-warn-teacher'}
          }
        ]
      },
      {
        path: '/my',
        component: () => import('./components/layout.vue'),
        meta: {title: '我的课程', icon: 'el-icon-school'},
        children: [
          {
            path: '/my/course',
            component: () => import('./views/system/my/index.vue'),
            meta: {title: '授课课程'}
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    component: () => import('./views/login/index.vue')
  },
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/forbidden',
    component: () => import('./views/forbidden.vue')
  }
];

export default new Router({
  //mode: 'history',
  routes
});
